import { render } from "./LocationSearchBox.vue?vue&type=template&id=57605d2c&ts=true"
import script from "./LocationSearchBox.vue?vue&type=script&lang=ts"
export * from "./LocationSearchBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__